// @context TGW-2195 既定画像の生成判定（詳細設計 §7.1）。
//   components/axios は import 時に csrf-token メタタグを読むため jsdom では素通しできない。
jest.mock('../axios', () => ({ post: jest.fn() }));

// eslint-disable-next-line import/first
import axios from '../axios';
// eslint-disable-next-line import/first
import { shouldGenerateDefaultImage, requestDefaultImage, withDefaultImage } from './default_image';

const title = (n) => 'あ'.repeat(n);

describe('shouldGenerateDefaultImage', () => {
  it('すでに画像があれば字数に関わらず false', () => {
    const event = { main_image_url_medium_strict: 'https://example.com/a.jpg' };
    expect(shouldGenerateDefaultImage(event, title(15))).toBe(false);
    expect(shouldGenerateDefaultImage(event, title(100))).toBe(false);
  });

  it('14字は false（下限未満）', () => {
    expect(shouldGenerateDefaultImage({}, title(14))).toBe(false);
  });

  it('15字は true', () => {
    expect(shouldGenerateDefaultImage({}, title(15))).toBe(true);
  });

  it('100字は true', () => {
    expect(shouldGenerateDefaultImage({}, title(100))).toBe(true);
  });

  it('101字は false（上限超過）', () => {
    expect(shouldGenerateDefaultImage({}, title(101))).toBe(false);
  });

  it('タイトルが空・未定義なら false', () => {
    expect(shouldGenerateDefaultImage({}, '')).toBe(false);
    expect(shouldGenerateDefaultImage({}, undefined)).toBe(false);
  });
});

describe('requestDefaultImage', () => {
  beforeEach(() => axios.post.mockReset());

  it('生成 API を叩き、main_image_url を返す', async () => {
    axios.post.mockResolvedValue({
      data: { main_image_url: 'https://example.com/generated.jpg' },
    });

    const url = await requestDefaultImage(123, 'ゆるっとカレー交流会をひらきます');

    expect(axios.post).toHaveBeenCalledWith(
      '/api/event/generate_default_image',
      JSON.stringify({ event_id: 123, event_title: 'ゆるっとカレー交流会をひらきます' })
    );
    expect(url).toBe('https://example.com/generated.jpg');
  });
});

describe('withDefaultImage', () => {
  it('カバーが未設定なら生成画像を入れる', () => {
    const prev = { title: 't', main_image_url_medium_strict: '' };
    expect(withDefaultImage('https://example.com/gen.jpg')(prev)).toEqual({
      title: 't',
      main_image_url_medium_strict: 'https://example.com/gen.jpg',
    });
  });

  it('生成中にユーザーがカバーを登録していたら上書きしない（同じ state を返す）', () => {
    const prev = { title: 't', main_image_url_medium_strict: 'https://example.com/user.jpg' };
    expect(withDefaultImage('https://example.com/gen.jpg')(prev)).toBe(prev);
  });
});
